export default "__VITE_PUBLIC_ASSET__0f22065d__"